import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { FirebaseContext } from "../../FirebaseInit";
import { lightBlue, pink } from "@material-ui/core/colors";
import myStyles from "./Style";

const INIT_STATE = {
  username: "",
  email: "",
  password: "",
  passwordCnf: "",
  error: null,
  loading: false,
};

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INIT_STATE };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value.trim(),
    });
  }

  handleSubmit(firebase, e) {
    e.preventDefault();
    this.setState({ loading: true });
    firebase
      .fs()
      .collection("users")
      .where("username_lc", "==", this.state.username.toLowerCase())
      .get()
      .then((doc) => {
        if(doc.empty){
          firebase
          .signUp(this.state.email, this.state.password)
          .then((authuser) => {
            authuser.user.updateProfile({
              displayName: this.state.username,
            });
            const profile = {
              email: this.state.email,
              username: this.state.username,
              username_lc:this.state.username.toLowerCase(),
              ppURL: null,
              timestamp: firebase.fs.Timestamp.now(),
            };
            const theme = {
              primaryColor: lightBlue[700],
              secondaryColor: pink[700],
              theme: "dark",
              uid: authuser.user.uid,
            };
            firebase
              .fs()
              .collection("users")
              .doc(authuser.user.uid)
              .set(profile)
              .catch((err) => console.log(err));
    
            firebase
              .fs()
              .collection("users")
              .doc(authuser.user.uid)
              .collection("private")
              .doc("theme")
              .set(theme)
              .then(() => {
                this.props.history.push("/dashboard");
              })
              .catch((err) => console.log(err));
          })
          .catch((error) => this.setState({ error: error.message, loading: false }));
        }

        else this.setState({error: 'Username already taken.', loading: false})
      })
      .catch(error => this.setState({ error: 'Unexpected error. Please try again.', loading: false }))

  }

  render() {
    const { classes } = this.props;
    const {
      username,
      email,
      password,
      passwordCnf,
      error,
      loading,
    } = this.state;
    const formNotValid =
      username === "" ||
      email === "" ||
      password === "" ||
      password !== passwordCnf;
    const firebase = this.context;
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mx={2}
      >
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4">
            Register
          </Typography>
          <form
            onSubmit={this.handleSubmit.bind(this, firebase)}
            className={classes.form}
          >
            <TextField
              variant="outlined"
              name="username"
              label="Username"
              required
              fullWidth
              value={username}
              onChange={this.handleChange}
              autoFocus
              margin="normal"
              inputProps={{ maxLength: 30 }}
            />

            <TextField
              variant="outlined"
              name="email"
              label="Email Address"
              required
              fullWidth
              value={email}
              onChange={this.handleChange}
              margin="normal"
            />

            <TextField
              variant="outlined"
              name="password"
              label="Password"
              required
              fullWidth
              value={password}
              onChange={this.handleChange}
              type="password"
              margin="normal"
            />

            <TextField
              variant="outlined"
              name="passwordCnf"
              label="Password Confirmation"
              required
              fullWidth
              value={passwordCnf}
              onChange={this.handleChange}
              type="password"
              margin="normal"
            />

            <Box my={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                disabled={formNotValid || loading}
              >
                Sign Up
              </Button>
            </Box>
            {error && (
              <Typography paragraph color="error">
                {error}
              </Typography>
            )}
            <Link className={classes.link} to="/login">
              Already have an account? Sign in.
            </Link>
          </form>
        </Paper>
      </Box>
    );
  }
}
Signup.contextType = FirebaseContext;
export default withStyles(myStyles)(Signup);
